// @ts-nocheck
// This file is auto-generated by tauri-specta. Do not edit.

// This file was generated by [tauri-specta](https://github.com/oscartbeaumont/tauri-specta). Do not edit this file manually.

/** user-defined commands **/


export const commands = {
async saveSettings(settings: string) : Promise<Result<null, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("save_settings", { settings }) };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Persists the theme preference and broadcasts a `theme-changed` event to ALL
 * windows so every already-open window re-applies the theme live.
 * 
 * Each Tauri window is an isolated WebviewWindow with its own localStorage, so
 * they cannot observe a localStorage-based theme change in another window. This
 * command owns the write + broadcast atomically: any window calling it persists
 * the choice (merging into settings.json without clobbering other fields) and
 * notifies every window — including itself. Re-applying the same `data-theme`
 * is a harmless no-op, so the echo to the sending window does not thrash.
 * 
 * The payload is the raw stored preference (`"light"`, `"dark"`, or `"system"`);
 * each window resolves `"system"` via matchMedia, mirroring launch-time logic.
 */
async setTheme(theme: string) : Promise<Result<null, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("set_theme", { theme }) };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
async loadSettings() : Promise<Result<string, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("load_settings") };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Returns the persisted theme preference (`"light"`, `"dark"`, or `"system"`),
 * or `null` if no preference has been saved yet.
 * 
 * Called by the recording-hud at startup to apply the correct theme before the
 * first React render. The recording-hud is a separate Tauri WebviewWindow and
 * cannot read the main window's localStorage or `data-theme` attribute, so
 * it must query the Tauri-persisted settings directly.
 * 
 * The caller (recording-hud's `main.tsx`) handles the `"system"` → matchMedia
 * resolution so this command stays simple and pure.
 */
async getActiveTheme() : Promise<Result<string | null, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("get_active_theme") };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
async exchangeAuthCode(tokenUrl: string, body: string) : Promise<Result<OAuthTokens, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("exchange_auth_code", { tokenUrl, body }) };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
async refreshAuthToken(tokenUrl: string, body: string) : Promise<Result<OAuthTokens, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("refresh_auth_token", { tokenUrl, body }) };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * RFC 7009 token revocation. Returns Ok(()) on any 2xx response — the
 * revoke endpoint returns 200 with an empty body on success, which would
 * fail parsing if we reused `exchange_auth_code`'s OAuthTokens path.
 */
async revokeOauthToken(revokeUrl: string, body: string) : Promise<Result<null, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("revoke_oauth_token", { revokeUrl, body }) };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Kicks off the passwordless email flow (Auth0 emails a 6-digit OTP).
 * 
 * Routed through Rust for the same reason as the other three commands:
 * WKWebView's CORS enforcement on `tauri://localhost` rejects the response
 * from `/passwordless/start` even though Auth0 sends a permissive
 * `Access-Control-Allow-Origin: *` header — the failure is client-side, not
 * a server allowlist gap.
 */
async startPasswordless(startUrl: string, body: string) : Promise<Result<null, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("start_passwordless", { startUrl, body }) };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Unified permission check. Tries the fresh-process Swift sidecar (uncached
 * TCC) first, falling back to in-process FFI. Sync so the sidecar `block_on`
 * runs outside any async worker (Tauri dispatches sync commands off the async
 * runtime).
 */
async checkPermission(kind: Permission) : Promise<PermissionStatus> {
    return await TAURI_INVOKE("check_permission", { kind });
},
/**
 * Unified request: trigger the OS prompt for `kind`, then re-check and return
 * the FRESH status. Screen-recording / system-audio requests persist
 * `has_prompted_screen_recording` so a subsequent no-grant check reports
 * `Denied` (never-asked vs explicitly-denied disambiguation).
 */
async requestPermission(kind: Permission) : Promise<Result<PermissionStatus, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("request_permission", { kind }) };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Unified deep-link: open System Settings to the Privacy pane for `kind`,
 * trying the candidate `x-apple.systempreferences:` URLs in preference order.
 * No-op on non-macOS. The `opener` spawn glue lives here; the URL list comes
 * from `nula_permissions::settings_pane_urls`.
 */
async openPermission(kind: Permission) : Promise<Result<null, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("open_permission", { kind }) };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Unified reset: clear the TCC entry for `kind` via `tccutil reset <service>
 * <bundle-id>` so the next request re-prompts cleanly. No-op on non-macOS.
 * The `tccutil` spawn glue lives here; the service name comes from
 * `nula_permissions::tccutil_service`.
 */
async resetPermissionKind(kind: Permission) : Promise<Result<null, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("reset_permission_kind", { kind }) };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Relaunch the app after a brief delay so the current window close is clean.
 * Used by `RestartRequired.tsx` after macOS Screen Recording grant.
 */
async restartApp() : Promise<Result<null, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("restart_app") };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * User clicked "Record" in the overlay. Dispatches to the appropriate
 * per-source handler based on the `source` discriminator.
 */
async meetingDetectedRecord(req: MeetingDetectedRecordRequest) : Promise<Result<null, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("meeting_detected_record", { req }) };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * User clicked "Dismiss" in the overlay. Just closes the window — no
 * recording started.
 * 
 * Suppression note: no explicit suppression write is needed here. The
 * calendar-notifier loop already writes `DismissalReason::Fired` for the
 * calendar event at fire-time (before the overlay opens), so the next 30s
 * rescan will skip it. The mic-detector path uses app-bundle-id keyed
 * suppressions written only on "Join & record" to prevent the mic-detect
 * overlay from double-firing after a calendar join; a mic-path dismiss does
 * not need a suppression because the detector's own observation window
 * prevents immediate re-fire.
 */
async meetingDetectedDismiss() : Promise<Result<null, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("meeting_detected_dismiss") };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Debug-only: open the MeetingDetectedOverlay with hardcoded params so QA
 * can visually verify the overlay without launching a real meeting app.
 * Compiled out of release builds.
 */
async meetingDetectedDebug() : Promise<Result<null, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("meeting_detected_debug") };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Start a recording, optionally linked to a calendar event.
 * 
 * Offline-first per design D-08:
 * 1. Generate a `client_temp_id` UUID locally.
 * 2. macOS: pre-flight check Screen Recording permission. If `RequiresRestart`,
 * bail with `RecordingStartError::RequiresRestart` BEFORE touching the
 * audio pipeline (avoids half-started UX).
 * 3. Build platform-specific `AudioSource` pair (mic + system).
 * 4. Spawn `run_audio_pipeline` on the Tauri async runtime.
 * 5. Insert into `ActiveRecordingRegistry` (in-memory, shared with the
 * reconciliation loop).
 * 6. Insert into `PendingStore` (SQLite, survives restart).
 * 7. Open the recording-hud via `open_recording_hud`.
 * 
 * The reconciliation loop (spawned at startup) picks up the new pending
 * row on its next tick (default 4 s) and `POST`s to `/api/entities`
 * (kind=recording). The pipeline is already running.
 * Start a recording. Per the recording-id-simplification design (Phase C):
 * 
 * 1. Acquire StartGuard (double-click prevention; second concurrent call
 * returns AlreadyStarting synchronously).
 * 2. macOS Screen Recording pre-flight check.
 * 3. Reject if any recording is already active on this device.
 * 4. Snapshot device identity + generate idempotency UUID.
 * 5. Build + start audio sources via AudioSourcesFactory; wrap session
 * in AudioRollbackGuard so any error before registry insert stops
 * audio cleanly.
 * 6. POST /api/entities with retry_with_backoff. Map 409 →
 * AlreadyRecording, retry-exhaustion → Other.
 * 7. Consume the rollback guard; insert into registry keyed by the
 * server-assigned recording_id.
 * 8. Open recording-hud + update tray (both non-fatal).
 * 9. Return RecordingHandleResponse with the real recording_id.
 */
async recordingStart(req: RecordingStartRequest) : Promise<Result<RecordingHandleResponse, RecordingStartError>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("recording_start", { req }) };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Stop an in-progress recording.
 * 
 * Behavior depends on reconciliation state:
 * - Reconciled: signal the pipeline to stop, then spawn `upload_recording`.
 * - Pending / InFlight: signal stop, mark `stop_queued=true` so the
 * reconciliation loop fires the upload as soon as the server response
 * lands.
 * - Failed: discard — the user's recording will not reach the server
 * anyway, so clean up.
 * 
 * Always closes the recording-hud (best-effort).
 */
async recordingStop(recordingId: string, reason: AutoEndReason | null) : Promise<Result<null, RecordingStopError>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("recording_stop", { recordingId, reason }) };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Discard an in-progress recording without saving. Stops the pipeline,
 * removes the registry + pending entries, and deletes the local .ogg
 * + any upload-state sidecar.
 */
async recordingDiscard(recordingId: string) : Promise<Result<null, RecordingDiscardError>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("recording_discard", { recordingId }) };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Pause an in-progress recording.
 * 
 * Sends `true` on the recording's pause watch channel. The audio pipeline
 * continues draining sources (to avoid backpressure) but skips encode, the
 * Ogg write, and the live-transcription frame tap while paused.
 * 
 * The heartbeat to the server keeps running — the recording remains "active"
 * server-side; only local capture is suspended.
 * 
 * Returns `NotFound` when the `recording_id` is not in the registry (already
 * stopped or never started) and `NoPauseChannel` when the entry exists but was
 * created before M5 shipped (no pause channel wired).
 */
async recordingPause(recordingId: string) : Promise<Result<null, RecordingControlError>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("recording_pause", { recordingId }) };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Resume a paused recording.
 * 
 * Sends `false` on the recording's pause watch channel. The pipeline resumes
 * encoding, writing, and forwarding frames to the live-transcription tap.
 * 
 * Symmetric with `recording_pause` — same error variants.
 */
async recordingResume(recordingId: string) : Promise<Result<null, RecordingControlError>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("recording_resume", { recordingId }) };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Query the CURRENT authoritative elapsed (ms, paused spans excluded) + paused
 * state for a recording. Returns `None` if the recording isn't active in the
 * registry (ended/unknown). This is the pull half of the elapsed contract: the
 * 1s `recording://elapsed` broadcast pushes updates, but a surface that mounts
 * mid-recording only hears FUTURE ticks — it queries this once on mount to seed
 * the value immediately rather than waiting up to ~1s for the next broadcast.
 */
async recordingGetElapsed(recordingId: string) : Promise<Result<RecordingElapsedPayload | null, RecordingControlError>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("recording_get_elapsed", { recordingId }) };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Return the current recording settings snapshot.
 * 
 * `browser_detection_enabled`, `app_detection_enabled`, and
 * `calendar_notifications_enabled` are read from the persisted
 * `PresenceSettings` store so restarts preserve the user's toggle choice.
 * All other fields are currently served from compile-time defaults.
 * 
 * Returns `Result<RecordingSettingsSnapshot, String>` because Tauri's
 * proc-macro requires async commands that borrow state to return `Result`.
 * This command is infallible on every path — the `Err` variant is dead code.
 */
async getRecordingSettings() : Promise<Result<RecordingSettingsSnapshot, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("get_recording_settings") };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Apply a partial settings patch.
 * 
 * `browserDetectionEnabled`, `appDetectionEnabled`,
 * `calendarNotificationsEnabled`, device IDs, and `shortcut` are persisted
 * via `PresenceSettings`. When `shortcut` is present the global OS shortcut
 * is re-registered immediately so the new key combo takes effect without a
 * restart.
 * 
 * LOG-ONLY: the persist step can fail (disk full, permission denied). On
 * failure the in-memory value is already updated (so the current session is
 * consistent) and the error is propagated to the React side so the toggle can
 * display an error state. The `Result<(), String>` signature is required by
 * Tauri's proc-macro (async + borrowed state).
 */
async updateRecordingSettings(patch: RecordingSettingsPatch) : Promise<Result<null, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("update_recording_settings", { patch }) };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Validate a shortcut string from the settings panel.
 * 
 * Returns `Ok(())` if the string is syntactically valid and not reserved.
 * Returns `Err(String)` (displayed inline in the shortcut capture UI) if
 * the shortcut is empty, malformed, or conflicts with a reserved hotkey.
 * 
 * Thin wrapper around `services::recording::shortcut::validate_shortcut` so
 * the settings panel can call it via `invoke("validate_shortcut", { shortcut })`.
 */
async validateShortcut(shortcut: string) : Promise<Result<null, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("validate_shortcut", { shortcut }) };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Return the static list of meeting apps that the auto-detector recognises.
 * 
 * The frontend uses this to populate the `AllowlistEditor` default-app list
 * (read-only entries that can't be removed). The `bundle_id` is the stable
 * key used in `allowedMeetingAppBundleIds` in the settings hook.
 */
async getMeetingAppAllowlist() : Promise<AllowlistEntry[]> {
    return await TAURI_INVOKE("get_meeting_app_allowlist");
},
/**
 * Return available input (microphone) devices via cpal.
 * 
 * Device ID = cpal device name, which is stable on macOS (CoreAudio UID-backed).
 * Returns an empty list on unsupported platforms or if no input devices are found.
 */
async listAudioDevices() : Promise<AudioDeviceInfo[]> {
    return await TAURI_INVOKE("list_audio_devices");
},
/**
 * Update the device label used for local display (e.g. `AlreadyRecording`
 * error message). Empty / whitespace-only inputs are ignored — the existing
 * value remains.
 * 
 * I9: previously the device label was captured by-value at app startup
 * and frozen for the process lifetime. Now the frontend can push a richer
 * label (e.g., a user-edited "MacBook Pro at home") and the next loop
 * tick picks it up.
 * 
 * G4/H3 / LOG-ONLY: returns `Result<(), String>` because Tauri's
 * proc-macro requires async commands that borrow state to return
 * `Result`. The body is `Ok(())` on every path — `DeviceIdentity::set_label`
 * is infallible (writes into a `tokio::sync::RwLock`). The `Err(String)`
 * arm is dead code; the React side never sees a rejection.
 */
async setDeviceLabel(label: string | null) : Promise<Result<null, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("set_device_label", { label }) };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Update the optional `originClientGroupId` advertised on
 * `POST /api/entities` (kind=recording). `None` clears it (advisory-only mode).
 * 
 * I9: same rationale as `set_device_label` — was previously frozen at
 * startup. The server uses `clientTempId` for idempotency
 * (see docs/1-projects/meeting-capture/design.md § Trigger → record flow,
 * point 4), so this is purely informational — never required.
 * 
 * G4/H3 / LOG-ONLY: same shape as `set_device_label` —
 * `Result<(), String>` is required by the macro, but the body is
 * always `Ok(())` (`DeviceIdentity::set_group_id` is infallible).
 */
async setClientGroupId(groupId: string | null) : Promise<Result<null, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("set_client_group_id", { groupId }) };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Push a Clerk session token into the calendar client so upcoming-event
 * polling can authenticate against the Nula API.
 * 
 * The frontend must call this command:
 * 1. Immediately after a successful Clerk login.
 * 2. On every token refresh (before the old token expires).
 * 3. With `null` on logout to clear the token.
 * 
 * Tauri commands requiring AppHandle / managed state cannot be unit-tested
 * without the full Tauri runtime — this command is verified via smoke-test
 * (Phase D integration test) instead.
 * 
 * G4/H3 / LOG-ONLY: `Result<(), String>` is required by the macro
 * (async + borrowed state), but the body is always `Ok(())` —
 * `CalendarHttpClient::set_auth_token` is infallible (writes into a
 * `RwLock<Option<String>>`).
 */
async setCalendarAuthToken(token: string | null) : Promise<Result<null, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("set_calendar_auth_token", { token }) };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Push a Clerk session token into the ApiClient used by the reconciliation
 * loop and uploader. The frontend must call this command:
 * 1. Immediately after a successful Clerk login.
 * 2. On every token refresh (before the old token expires).
 * 3. With `null` on logout to clear the token.
 * 
 * When a non-null token arrives, also triggers a best-effort orphan-upload
 * scan so recordings that crashed mid-upload during a logged-out session are
 * resumed immediately after login (rather than waiting until the next cold
 * start with a token already set).
 * 
 * Tauri commands requiring AppHandle / managed state cannot be unit-tested
 * without the full Tauri runtime — this command is verified via smoke-test
 * (Phase D integration test) instead.
 * 
 * G4/H3 / LOG-ONLY: same shape as `set_calendar_auth_token` —
 * `Result<(), String>` is macro-required, body is always `Ok(())`
 * (`ApiClient::set_auth_token` is infallible).
 */
async setRecordingAuthToken(token: string | null) : Promise<Result<null, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("set_recording_auth_token", { token }) };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Push the active workspace ID into the ApiClient. The frontend calls this
 * whenever the user switches workspaces so that all subsequent recording API
 * calls (create, upload-start, upload-complete, heartbeat, delete) carry the
 * correct `X-Workspace-ID` header without per-call patching.
 */
async setRecordingWorkspaceId(workspaceId: string | null) : Promise<Result<null, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("set_recording_workspace_id", { workspaceId }) };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Apply a peer device's `recording.started` entity event so the local
 * notifier stays quiet for the same meeting / time window.
 * 
 * Called from `apps/lumen/src/sync/entityEventHandler.ts` whenever a
 * `recording.started` syncEvent arrives over the WebSocket. Self-originated
 * events (where `originClientGroupId` matches our local `DeviceIdentity::group_id`)
 * are no-oped — we already know we're recording.
 * 
 * LOG-ONLY: The body delegates to
 * [`crate::services::recording::cross_device_suppressor::apply_peer_recording_started`]
 * which propagates a `String` error from the suppression-store persist
 * step (disk full, permission denied). The React side does not pattern-
 * match on this — failure means the next local notification might fire
 * once on the peer's recording, but the user can dismiss it. The
 * `Result<(), String>` signature is required by Tauri's proc-macro
 * (async + borrowed state).
 */
async applyCrossDeviceSuppression(event: PeerRecordingStarted) : Promise<Result<null, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("apply_cross_device_suppression", { event }) };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Invoked when the user dismisses/skips the meeting notification.
 * Marks the calendar event as suppressed so the notifier will not re-fire
 * on its next 30-second scan.
 * 
 * The `Dismissals` Arc is managed in app state (wired in
 * `lib.rs` at startup, alongside the notifier loop that reads from it).
 * 
 * LOG-ONLY: `add_suppression()` can fail at the persist step (disk full,
 * permission denied). Errors are logged via the host but the React side
 * does not pattern-match on them — keeping the suppression in-memory is
 * the practical recovery path until the next successful persist. The
 * `Result<(), String>` signature is retained for ergonomic logging in the
 * host but the failure mode is not surfaced to React.
 */
async recordingNotificationSkipped(calendarEventId: string) : Promise<Result<null, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("recording_notification_skipped", { calendarEventId }) };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Handle the user's (or auto-dismiss's) response to the "Still recording?"
 * overlay.
 * 
 * `action: "keep"` emits `recording-still-active-acknowledged` so the
 * originating watcher marks this recording's suppression flag.
 * `action: "stop"` invokes `recording_stop` with the typed `trigger_reason`.
 * 
 * `trigger_reason` is the snake-case form of `AutoEndReason` (`mic_release`
 * or `tab_closed`); other variants are rejected as `Other`.
 */
async stillRecordingResponse(action: StillRecordingAction, recordingId: string, triggerReason: AutoEndReason) : Promise<Result<null, StillRecordingError>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("still_recording_response", { action, recordingId, triggerReason }) };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Enables rounded corners for the window (macOS only)
 * Uses only public APIs - App Store compatible
 */
async enableRoundedCorners() : Promise<Result<null, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("enable_rounded_corners") };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Enables modern window style with rounded corners and shadow
 */
async enableModernWindowStyle(cornerRadius: number | null) : Promise<Result<null, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("enable_modern_window_style", { cornerRadius }) };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Re-apply the native window vibrancy tint for a theme change so the frost
 * follows the app theme. Cross-platform: macOS sets the `NSAppearance`, Windows
 * re-applies Mica with the matching `dark` flag, other platforms no-op. Called
 * from the client on every theme change. `theme` is "light", "dark", or "system".
 */
async setWindowTheme(theme: string) : Promise<Result<null, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("set_window_theme", { theme }) };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Resize the recording HUD between collapsed and expanded, keeping the window
 * horizontally centered and anchored to its bottom edge so it grows upward in
 * place (bottom-center home), clamped into the visible frame.
 */
async recordingHudSetExpanded(expanded: boolean) : Promise<Result<null, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("recording_hud_set_expanded", { expanded }) };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Grow the expanded HUD to a chat-comfortable height when the Ask-Nula chat
 * pane opens — but ONLY if the window is currently shorter than that. A taller
 * window (user dragged it up, or a prior chat-open already grew it) is left
 * untouched, so this never fights a manual resize. Bottom-anchored + centered
 * like `recording_hud_set_expanded`, so it grows upward in place. Width is
 * preserved (the user may have widened the panel). No-op when the window is
 * missing or already tall enough. Closing the pane does NOT shrink the window —
 * the freed space returns to the notes/transcript area (design decision).
 */
async recordingHudEnsureChatHeight() : Promise<Result<null, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("recording_hud_ensure_chat_height") };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
},
/**
 * Focus the main window and optionally navigate to an entity (the recording's
 * notes document). Called by the recording-hud's "Open notes" button.
 * 
 * The param is `entity_id` (not `doc_id`): the JS side invokes with
 * `{ entityId }`, which Tauri v2 maps to the snake_case `entity_id`. The old
 * `doc_id` name never matched, so the command always received `None` and never
 * emitted `focus-doc` — the navigation was silently dead.
 */
async focusMainFromHud(entityId: string | null) : Promise<Result<null, string>> {
    try {
    return { status: "ok", data: await TAURI_INVOKE("focus_main_from_hud", { entityId }) };
} catch (e) {
    if(e instanceof Error) throw e;
    else return { status: "error", error: e  as any };
}
}
}

/** user-defined events **/


export const events = __makeEvents__<{
calendarConnected: CalendarConnectedPayload,
focusDoc: FocusDocPayload,
navigate: NavigatePayload,
oauthCallback: OauthCallbackPayload,
openSettings: OpenSettingsPayload,
recordingAutoStopped: RecordingAutoStoppedPayload,
recordingDiscardRequested: RecordingDiscardRequestedPayload,
recordingPrefill: RecordingPrefillPayload,
recordingStartRequested: RecordingStartRequestedPayload,
recordingStillActiveAcknowledged: StillActiveAcknowledgedPayload,
recordingStopRequested: RecordingStopRequestedPayload,
recordingAmplitude: AmplitudePayload,
recordingElapsed: RecordingElapsedPayload,
recordingPaused: RecordingPausedPayload,
recordingTranscript: TranscriptPayload,
recordingVad: VadPayload,
themeChanged: ThemeChangedPayload
}>({
calendarConnected: "calendar-connected",
focusDoc: "focus-doc",
navigate: "navigate",
oauthCallback: "oauth-callback",
openSettings: "open-settings",
recordingAutoStopped: "recording-auto-stopped",
recordingDiscardRequested: "recording-discard-requested",
recordingPrefill: "recording-prefill",
recordingStartRequested: "recording-start-requested",
recordingStillActiveAcknowledged: "recording-still-active-acknowledged",
recordingStopRequested: "recording-stop-requested",
recordingAmplitude: "recording://amplitude",
recordingElapsed: "recording://elapsed",
recordingPaused: "recording://paused",
recordingTranscript: "recording://transcript",
recordingVad: "recording://vad",
themeChanged: "theme-changed"
})

/** user-defined constants **/



/** user-defined types **/

/**
 * Wire-facing allowlist entry returned by `get_meeting_app_allowlist`.
 * 
 * `bundle_id` is the macOS bundle ID used as the canonical stable key.
 * `display_name` is the human-readable app name.
 * `icon_path` is reserved for future icon support (always null for now).
 */
export type AllowlistEntry = { bundleId: string; displayName: string; iconPath: string | null }
/**
 * Payload for the `recording://amplitude` event emitted to the recording HUD
 * at ~25Hz (every other pipeline frame). Drives the mic-reactive waveform.
 */
export type AmplitudePayload = { recordingId: string; rms: number }
/**
 * Wire-facing audio device returned by `list_audio_devices`.
 */
export type AudioDeviceInfo = { id: string; name: string }
/**
 * Why a recording was stopped. Wire format: snake_case
 * (`"user"` | `"hard_cap"` | `"mic_release"` | `"tab_closed"` |
 * `"app_quit"` | `"app_exit"`).
 */
export type AutoEndReason = "user" | "hard_cap" | "mic_release" | 
/**
 * Browser-tab originating the recording disappeared from the
 * browser_tab DetectionSource for ≥2 consecutive ticks (session 9 D2).
 */
"tab_closed" | 
/**
 * User confirmed Stop & Quit on the app-quit dialog with active
 * recordings (session 9 D3).
 */
"app_quit" | 
/**
 * The meeting app (Zoom/Teams/etc.) that owned the mic for this
 * recording exited entirely — its process is no longer running. Distinct
 * from `MicRelease` (mic freed but app still alive): catches hard quits
 * and crashes that the mic-release hysteresis would otherwise wait out.
 */
"app_exit"
/**
 * Payload for `calendar-connected`. Unit event — no data carried.
 * Wire-shape: `null` (matches `app.emit("calendar-connected", ())`).
 */
export type CalendarConnectedPayload = null
export type CommittedTurnPayload = { turnOrder: number; text: string; speakerLabel: string | null; 
/**
 * Milliseconds from the start of the audio stream to this turn's first
 * word, for the transcript's timestamp gutter. `None` when the turn
 * carried no word timings.
 */
startMs: number | null }
/**
 * Why a meeting signal fired. The frontend uses this to render
 * source-aware overlay copy (calendar = "Join & record", browser_tab =
 * "Record this meeting", mic_owner = "Are you in a call in {app}?").
 */
export type DetectionSource = "calendar" | "browser_tab" | "mic_owner"
/**
 * Payload for `focus-doc`. The value is the entity ID string to focus.
 * Wire-shape: plain string (matches `main.emit("focus-doc", id)`).
 */
export type FocusDocPayload = string
/**
 * Request payload for the unified `meeting_detected_record` command.
 */
export type MeetingDetectedRecordRequest = { source: DetectionSource; 
/**
 * Required when source = Calendar (URL to open in browser).
 */
url: string | null; 
/**
 * Required when source = Calendar (passed as calendar context to recording start).
 */
eventId: string | null; 
/**
 * Required when source = MicOwner (used to write the app-key suppression).
 */
appBundleId: string | null; title: string | null; 
/**
 * True when system-audio capture is unavailable for this meeting
 * (e.g. Slack huddles). The recording-start path will read this in
 * session 7 to select mic-only mode. For now the field is carried
 * through but not acted on.
 */
audioOnlyCapture?: boolean; 
/**
 * Browser-tab dedup key (session 9 D2). Set only when
 * `source == BrowserTab`. Forwarded on the `recording-start-requested`
 * event so `recording_start` can store it on the
 * ActiveRecording handle for the controller's tab-close watcher to
 * reconcile against.
 */
browserTabDedupKey?: string | null }
/**
 * Payload for `navigate`. The `path` field carries the deep-link target.
 * Wire-shape: `{ "path": "..." }` (matches `json!({"path": path})`).
 */
export type NavigatePayload = { path: string }
export type OAuthTokens = { access_token: string; id_token: string; refresh_token?: string | null; token_type: string; expires_in: number }
/**
 * Payload for `oauth-callback`. The `url` field carries the full redirect URL.
 * Wire-shape: `{ "url": "nula://oauth-callback?..." }` (matches `json!({"url": url_str})`).
 */
export type OauthCallbackPayload = { url: string }
/**
 * Payload for `open-settings`. Unit event — no data carried.
 * Wire-shape: `null` (matches `app.emit("open-settings", ())`).
 */
export type OpenSettingsPayload = null
/**
 * Wire-format payload received from JS when a peer device emits
 * `recording.started`.
 * 
 * Field names use camelCase on the wire to match the existing
 * `RecordingStartedPayload` type in `apps/lumen/src/sync/entityEvents/recording.ts`
 * and the API emitter in
 * `apps/api/nexus/services/entity_events.rs::build_recording_started_data`.
 * The wire-format guard test below pins this contract.
 */
export type PeerRecordingStarted = { 
/**
 * Server-assigned recording id. Used as the cross-device suppression
 * key when `calendar_event_id` is None.
 */
recordingId: string; 
/**
 * Calendar event id, if this recording was triggered from a calendar
 * notification. When present, the suppression key matches the existing
 * `DismissalKey::calendar(...)` namespace so the local notifier's
 * existing check is a direct hit.
 */
calendarEventId: string | null; 
/**
 * Per-device group id of the device that started the recording. We
 * compare this against our own `DeviceIdentity::group_id` — if equal,
 * this event originated here and we skip the suppression entirely
 * (we already know we're recording).
 */
originClientGroupId: string | null; 
/**
 * ISO-8601 timestamp the server stamped on the recording. Currently
 * unused by the suppression logic but kept on the wire for future
 * time-window fallback work and for debug logging.
 */
startedAt: string }
export type Permission = "microphone" | "systemAudio" | "screenRecording" | "accessibility" | "inputMonitoring" | "calendar" | "reminders" | "contacts"
/**
 * Coarse permission state for a single OS-level capability.
 * 
 * camelCase wire format per CLAUDE.md's JS-facing convention. Variant WORDS
 * are kept from Nula's pre-unification enum (NotDetermined/Granted/Denied) to
 * minimise churn on the React side — only the casing changes
 * (`not_determined` → `notDetermined`), so most frontend string comparisons
 * (`=== "granted"`, `=== "denied"`) survive untouched.
 */
export type PermissionStatus = 
/**
 * The user has never been prompted for this permission.
 */
"notDetermined" | 
/**
 * The user denied (or it is otherwise unavailable: restricted, etc.).
 */
"denied" | 
/**
 * The permission is granted and active.
 */
"granted"
/**
 * Payload for the `recording-auto-stopped` Tauri event. Emitted only for
 * silent auto-stops (HardCap) — MicRelease and TabClosed both
 * route through the still-recording overlay where the user explicitly chose
 * Stop, so a follow-up toast would be redundant. User is not an auto-stop.
 */
export type RecordingAutoStoppedPayload = { recordingId: string; reason: AutoEndReason }
/**
 * Structured failure modes for `recording_pause` and `recording_resume`.
 */
export type RecordingControlError = 
/**
 * No active recording found in the registry for the given id.
 */
{ kind: "not_found" } | 
/**
 * The recording is active but its pause channel is not yet wired
 * (pause_tx is None — only possible on recordings started before M5
 * shipped, or in tests that pre-populate the registry with a stub).
 */
{ kind: "no_pause_channel" }
/**
 * Structured failure modes for `recording_discard`. Serialised as the
 * JS Promise rejection value when the command returns `Err(...)`.
 */
export type RecordingDiscardError = 
/**
 * `client_temp_id` did not resolve to any active recording in the
 * registry. Discard is best-effort; this variant is reserved for a
 * future strict-mode flag.
 */
{ kind: "not_found" } | 
/**
 * Local file / SQLite cleanup error. Currently only exercised by the
 * wire-format guard test — discard's cleanup is best-effort and logs
 * rather than fails.
 */
{ kind: "io"; message: string } | 
/**
 * Catch-all (e.g. malformed `client_temp_id` UUID).
 */
{ kind: "other"; message: string }
/**
 * Payload for `recording-discard-requested`. The value is the `client_temp_id`
 * of the recording to discard.
 * Wire-shape: plain string (matches `app.emit("recording-discard-requested", temp_id.to_string())`).
 */
export type RecordingDiscardRequestedPayload = string
/**
 * Payload for the `recording://elapsed` Tauri event + the `recording_get_elapsed`
 * query. Carries the wall-clock ANCHOR (not a pre-computed integer) so every
 * surface ticks elapsed locally and smoothly from the same anchor — synced to
 * the ms across windows, no per-surface drift, no 1s-frozen value. The anchor
 * only changes on pause/resume, so it's broadcast then (+ once at start); a
 * surface mounting mid-recording queries it. All times epoch ms; `pausedAtMs`
 * is null while running.
 */
export type RecordingElapsedPayload = { recordingId: string; startedAtMs: number; accumulatedPausedMs: number; pausedAtMs: number | null }
/**
 * Public response shape for `recording_start`. `documentEntityId` is the
 * notes-document entity id (`recordings.doc_id`) the HUD notes editor binds
 * to — distinct from `recordingId`. NOTE: the client JS discards this
 * response (the HUD is opened natively), so there is no client consumer.
 */
export type RecordingHandleResponse = { recordingId: string; documentEntityId: string }
/**
 * Payload for the `recording://paused` Tauri event. Broadcast to ALL windows
 * (via `AppHandle::emit`) on every pause/resume transition so any surface — the
 * HUD pill, the HUD expanded header, the main-window audio surface transport —
 * can reflect the SAME paused state. The registry's pause watch channel stays
 * the source of truth; this event just announces transitions across webviews
 * (recording state is desktop-local — the server is never involved).
 */
export type RecordingPausedPayload = { recordingId: string; isPaused: boolean }
/**
 * Payload for `recording-prefill`. The value is the calendar event ID string
 * used to pre-fill the recording-start dialog title from the tray menu.
 * Wire-shape: plain string (matches `app.emit("recording-prefill", event_id)`).
 */
export type RecordingPrefillPayload = string
/**
 * Patch payload accepted by `update_recording_settings`.
 * 
 * Every field is `Option<T>` so callers can send only the fields they want to
 * change. Fields that are `None` in the patch are left unchanged.
 * 
 * camelCase on the wire so `invoke("update_recording_settings", { browserDetectionEnabled: true })`
 * works from the React side without manual key translation.
 */
export type RecordingSettingsPatch = { browserDetectionEnabled: boolean | null; 
/**
 * App-based (mic-owner) detection toggle. `#[serde(alias)]` accepts the
 * pre-split `autoDetectEnabled` key so a client built before the split
 * still applies correctly during a staged rollout.
 */
appDetectionEnabled: boolean | null; calendarNotificationsEnabled: boolean | null; 
/**
 * `Some(Some(id))` = select device, `Some(None)` = revert to OS default, `None` = no change.
 */
micDeviceId?: string | null; 
/**
 * `Some(Some(id))` = select device, `Some(None)` = revert to OS default, `None` = no change.
 */
systemAudioDeviceId?: string | null; 
/**
 * `Some(s)` = update the recording-toggle shortcut, `None` = no change.
 */
shortcut: string | null; 
/**
 * `Some(b)` = update auto-join, `None` = no change.
 */
autoJoinEnabled: boolean | null; 
/**
 * `Some(b)` = update auto-end, `None` = no change.
 */
autoEndEnabled: boolean | null; 
/**
 * `Some(secs)` = update the end-grace window, `None` = no change.
 */
endGraceSecs: number | null }
/**
 * Wire-facing snapshot returned by `get_recording_settings`.
 * 
 * Every field is camelCase on the wire (see wire-format guard test below).
 * Defaults: 30-day retention, calendar-notifications + auto-detect on
 * (opt-out), browser-detection off (opt-in / AX-gated),
 * platform-appropriate shortcut, no device overrides.
 * 
 * Fields that don't have a backing store yet are served from compile-time
 * defaults — callers should treat these as UI defaults, not persisted values.
 */
export type RecordingSettingsSnapshot = { audioRetentionDays: number | null; calendarNotificationsEnabled: boolean; 
/**
 * App-based (mic-owner) meeting detection — Slack, Zoom, Teams. Wire key
 * `appDetectionEnabled`. On by default (opt-out).
 */
appDetectionEnabled: boolean; allowedMeetingAppBundleIds: string[]; shortcut: string; micDeviceId: string | null; systemAudioDeviceId: string | null; 
/**
 * Whether browser-tab presence detection is enabled.
 * Off by default — user must grant AX permission + enable the toggle.
 */
browserDetectionEnabled: boolean; 
/**
 * Whether auto-join (calendar meetings auto-record without a prompt) is on.
 */
autoJoinEnabled: boolean; 
/**
 * Whether auto-end (silently stop instead of "still recording?") is on.
 */
autoEndEnabled: boolean; 
/**
 * Grace seconds before an end signal acts (mic-release hysteresis +
 * tab-close threshold + auto-end delay).
 */
endGraceSecs: number }
/**
 * Structured failure modes for `recording_start`. Serialised as the
 * JS Promise rejection value when the command returns `Err(...)`.
 */
export type RecordingStartError = 
/**
 * Another recording_start invocation is in flight on this device
 * (double-click guard). React treats this as a silent no-op — the
 * first call will produce a recording and the user already sees a
 * loading state on the Record button.
 */
{ kind: "already_starting" } | 
/**
 * User has granted Screen Recording in System Settings but the app has
 * not restarted yet (macOS quirk — `ScreenCaptureKit` doesn't pick up
 * the new permission until a fresh process). React shows the
 * "restart required" modal.
 */
{ kind: "requires_restart" } | 
/**
 * macOS 14.4+ split-permission: Screen Recording is granted (screen
 * content enumerates) but the separate "System Audio Recording" half is
 * not. Restarting won't help — React shows an "enable System Audio
 * Recording in System Settings" remedy, distinct from `RequiresRestart`.
 */
{ kind: "enable_system_audio_half" } | 
/**
 * Screen Recording explicitly denied. Recording would degrade to
 * mic-only (out of scope for v1) — the React side surfaces a Settings
 * link.
 */
{ kind: "screen_recording_denied" } | 
/**
 * Microphone explicitly denied. Recording cannot proceed — surface
 * the Settings link.
 */
{ kind: "microphone_denied" } | 
/**
 * Microphone permission not yet prompted. The React side triggers the
 * prompt via `request_microphone_permission`. Reserved for an explicit
 * pre-flight permission-check path; the cpal mic source collapses
 * "not determined" into the OS prompt + a PermissionDenied on Deny, so
 * `recording_start` itself currently only emits `MicrophoneDenied`.
 */
{ kind: "microphone_not_determined" } | 
/**
 * Another device (or the same device, edge case) is already recording.
 * Carries the device label so the UI can show "you're recording on
 * {device_label}".
 */
{ kind: "already_recording"; device_label: string } | 
/**
 * The API returned 401 — the stored JWT has expired. The JS side should
 * refresh the token and retry recording_start once.
 */
{ kind: "unauthorized" } | 
/**
 * The workspace is at or below the credit floor, so the server refused to
 * create the recording (402 `insufficient_credits`). Distinct from the
 * other 402, `workspace_read_only` (a canceled team subscription), which
 * maps to the generic error.
 * 
 * `balance` can be NEGATIVE — the floor is -500, not 0. It is `None` when
 * the server omitted the detail.
 */
{ kind: "credit_limit_reached"; balance: number | null } | 
/**
 * Catch-all for transport errors, audio-subsystem failures, etc. that
 * don't have a more specific variant. The `message` is forwarded to
 * the user verbatim — keep it concise.
 */
{ kind: "other"; message: string }
/**
 * Bundled JS-visible args for `recording_start`.
 * 
 * Bundles the 5 JS-visible parameters into a single struct so specta can
 * export the command. specta rc.22's `SpectaFn` blanket impl only covers up to
 * 10 total params; `recording_start` had 13 (8 State/AppHandle + 5
 * JS-visible). Bundling drops the total arity to 9 (8 injected + 1 struct),
 * within the specta limit.
 */
export type RecordingStartRequest = { calendarEventId: string | null; title: string; audioOnlyCapture: boolean | null; browserTabDedupKey: string | null; sourceBundleId: string | null; 
/**
 * Existing entity to record INTO. `None` → the server creates one.
 */
entityId: string | null; 
/**
 * The document surface that asked for this recording, when one did.
 */
surfaceId: string | null }
/**
 * Payload emitted on `recording-start-requested`, carrying whatever context
 * the source has: calendar event, browser-tab dedup key, or nothing at all.
 * Every emitter sends this struct — the tray and shortcut send it with all
 * fields `None` rather than a unit payload, so listeners need no null guard.
 */
export type RecordingStartRequestedPayload = { calendarEventId: string | null; title: string | null; 
/**
 * Set when the originating source was a browser tab (session 9 D2).
 * `None` for calendar-originated starts. Always `None` for the
 * MicOwner path (no tab to track).
 */
browserTabDedupKey?: string | null; 
/**
 * Native-app bundle id (macOS) / exe name (Windows) of the app that
 * owned the mic when the meeting was detected. Set only when the
 * originating source was MicOwner (Zoom desktop, Slack huddle, etc.).
 * `None` for browser-tab and calendar sources. Used by the tier-2
 * release watcher to gate the "Still recording?" prompt on bundle
 * match — prevents false-positive prompts when an unrelated
 * allowlisted app briefly grabs and releases the mic during a
 * browser-tab Meet recording.
 */
sourceBundleId?: string | null; 
/**
 * Existing entity to record INTO (e.g. a document's Record affordance);
 * None for tray/shortcut/meeting-detected sources.
 */
entityId?: string | null; 
/**
 * The document surface that asked for this recording, when one did.
 * Always `None` for tray/shortcut/meeting-detected sources — an
 * externally-detected meeting has no originating surface.
 */
surfaceId?: string | null }
/**
 * Structured failure modes for `recording_stop`. Serialised as the
 * JS Promise rejection value when the command returns `Err(...)`.
 */
export type RecordingStopError = 
/**
 * `client_temp_id` did not resolve to any active recording in the
 * registry (already stopped, never started, or wrong id).
 */
{ kind: "not_found" } | 
/**
 * Internal invariant violated — e.g. a Reconciled-status row is missing
 * its server-assigned `recording_id`. Indicates a bug or a torn write
 * from a prior crash. The React side surfaces "out of sync — please
 * restart Nula" so the user has a deterministic recovery path.
 */
{ kind: "state_mismatch"; detail: string } | 
/**
 * SQLite / filesystem error. Local-only operations like
 * `mark_stop_queued` or sidecar deletes go here.
 */
{ kind: "io"; message: string } | 
/**
 * Upload pipeline failure surfaced synchronously from `recording_stop`.
 * Most upload errors fire inside the spawned task and only reach the
 * log; this variant is reserved for failures that happen before the
 * spawn. Currently exercised only by the wire-format guard test.
 */
{ kind: "uploader"; message: string } | 
/**
 * Catch-all for failures that don't have a more specific variant
 * (e.g. malformed `client_temp_id` UUID).
 */
{ kind: "other"; message: string }
/**
 * Payload for `recording-stop-requested`. The value is the `client_temp_id`
 * of the recording to stop.
 * Wire-shape: plain string (matches `app.emit("recording-stop-requested", temp_id_str)`).
 */
export type RecordingStopRequestedPayload = string
/**
 * Payload emitted on `recording-still-active-acknowledged` when the user
 * clicks "Keep recording". Session 9's `release_watcher` listens for this to
 * set the tier-2 mic-release suppression flag; the `trigger_reason` field lets
 * it pick out the events that pertain to it (the tab-close path pre-marks its
 * own flag before prompting, so it does not rely on this event).
 */
export type StillActiveAcknowledgedPayload = { recordingId: string; 
/**
 * Snake-case `AutoEndReason` (`"mic_release"` or `"tab_closed"`).
 * Used by the watcher to disambiguate which suppression flag to flip.
 */
triggerReason: string }
/**
 * Action chosen by the user (or triggered by auto-dismiss timeout).
 */
export type StillRecordingAction = "keep" | "stop"
/**
 * Structured errors returned by `still_recording_response`.
 */
export type StillRecordingError = 
/**
 * The recording identified by `client_temp_id` / `recording_id` is not
 * in the active registry (already stopped, discarded, or never started).
 */
{ kind: "not_found" } | 
/**
 * Stop failed for an internal reason (underlying `recording_stop` error).
 */
{ kind: "stop_failed"; message: string } | 
/**
 * Internal error (e.g. UUID parse failure).
 */
{ kind: "other"; message: string }
/**
 * Payload for `theme-changed`. The value is the raw stored preference:
 * `"light"`, `"dark"`, or `"system"`.
 * Wire-shape: plain string (matches `app.emit("theme-changed", &theme)`).
 */
export type ThemeChangedPayload = string
/**
 * Payload for the `recording://transcript` event, broadcast to every window
 * (both the recording HUD and the main window's document surface subscribe).
 * `activeTurn` is the current partial turn text (cleared when the turn finalises);
 * `committed` carries newly-finalized turns to append in the transcript view.
 * The live transcript is ephemeral — the batch pass (M2) is authoritative.
 */
export type TranscriptPayload = { recordingId: string; 
/**
 * Current partial turn text, if any.
 */
activeTurn: string | null; 
/**
 * Newly finalized turns to append.
 */
committed: CommittedTurnPayload[] }
/**
 * Payload for the `recording://vad` event emitted to the recording HUD.
 * `speechActive` is the VAD's current confirmed speech state — the HUD gates
 * the waveform glow on it so the bars react to *speech*, not raw energy.
 */
export type VadPayload = { recordingId: string; speechActive: boolean }

/** tauri-specta globals **/

import {
	invoke as TAURI_INVOKE,
	Channel as TAURI_CHANNEL,
} from "@tauri-apps/api/core";
import * as TAURI_API_EVENT from "@tauri-apps/api/event";
import { type WebviewWindow as __WebviewWindow__ } from "@tauri-apps/api/webviewWindow";

type __EventObj__<T> = {
	listen: (
		cb: TAURI_API_EVENT.EventCallback<T>,
	) => ReturnType<typeof TAURI_API_EVENT.listen<T>>;
	once: (
		cb: TAURI_API_EVENT.EventCallback<T>,
	) => ReturnType<typeof TAURI_API_EVENT.once<T>>;
	emit: null extends T
		? (payload?: T) => ReturnType<typeof TAURI_API_EVENT.emit>
		: (payload: T) => ReturnType<typeof TAURI_API_EVENT.emit>;
};

export type Result<T, E> =
	| { status: "ok"; data: T }
	| { status: "error"; error: E };

function __makeEvents__<T extends Record<string, any>>(
	mappings: Record<keyof T, string>,
) {
	return new Proxy(
		{} as unknown as {
			[K in keyof T]: __EventObj__<T[K]> & {
				(handle: __WebviewWindow__): __EventObj__<T[K]>;
			};
		},
		{
			get: (_, event) => {
				const name = mappings[event as keyof T];

				return new Proxy((() => {}) as any, {
					apply: (_, __, [window]: [__WebviewWindow__]) => ({
						listen: (arg: any) => window.listen(name, arg),
						once: (arg: any) => window.once(name, arg),
						emit: (arg: any) => window.emit(name, arg),
					}),
					get: (_, command: keyof __EventObj__<any>) => {
						switch (command) {
							case "listen":
								return (arg: any) => TAURI_API_EVENT.listen(name, arg);
							case "once":
								return (arg: any) => TAURI_API_EVENT.once(name, arg);
							case "emit":
								return (arg: any) => TAURI_API_EVENT.emit(name, arg);
						}
					},
				});
			},
		},
	);
}
